import React from 'react';

import { BootstrapButton } from '../bootstrap-button/BootstrapButton';
import * as StepperTypes from '.';

export interface StepperFooter {
    steps: Array<StepperTypes.Step>;
    footer?: ({ steps, activeStep, handleBack, handleNext }: StepperTypes.Footer) => React.ReactNode | any;
    activeStep: number;
    backButtonText?: React.ReactNode;
    nextButtonText: React.ReactNode;
    handleBack: () => any;
    handleNext: () => any;
}

export const StepperFooter = ({
    steps,
    activeStep,
    handleBack,
    handleNext,
    backButtonText,
    nextButtonText,
    footer,
}: StepperFooter) => {
    if (footer) {
        return footer({ steps, activeStep, handleBack, handleNext });
    }
    return (
        <div className="d-flex justify-content-between mx-2 flex-shrink-0" style={{ marginTop: 'auto' }}>
            <BootstrapButton
                ariaLabel="Back"
                disabled={activeStep === 0}
                onClick={handleBack}
                color="default"
                className="mr-2 back-button"
            >
                {backButtonText}
            </BootstrapButton>
            <BootstrapButton
                ariaLabel="Next"
                color={steps[activeStep].nextButtonStyle as any || 'primary'}
                onClick={handleNext}
            >
                {nextButtonText}
            </BootstrapButton>
        </div>
    );
};

StepperFooter.defaultProps = {
    backButtonText: 'Go Back',
    nextButtonText: 'Next',
    completionButtonText: 'Back to Home',
}

export default StepperFooter;